import { CtaButton, RuggedTrashCan, Spinner } from '@zappyrent/hundop';
import { rem, rgba } from 'polished';
import styled from 'styled-components';

export const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  appearance: none;

  &:not(:first-child) {
    margin-left: ${rem('12px')};
  }
`;

export const StyledDeleteIcon = styled(RuggedTrashCan)`
  width: auto;
  height: ${rem('24px')};

  path {
    fill: ${({ theme }) => theme.colors.cross.red};
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end; // Aligns children (button) to the right
`;

export const RowContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledContinueButton = styled(CtaButton).attrs({
  tag: 'button',
  user: 'tenant',
})`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${rem('10px')};
  text-transform: uppercase;
  margin: 0;

  span {
    position: relative;
  }

  &:hover {
    color: ${({ theme, variant }) =>
      variant === 'secondary' && theme.colors.tenant.mainAlternate};
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    max-width: ${rem('264px')};
    width: 100%;
  }
`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  gap: ${rem('10px')};
  align-items: center;
`;

export const StyledSubSection = styled.div`
  margin-bottom: ${rem('40px')};

  &:last-child {
    margin-bottom: ${rem('16px')};
  }
`;

export const StyledAddPaymentCta = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${rem('24px')} ${rem('16px')};
  background-color: transparent;
  border: ${rem('1px')} dashed ${({ theme }) => theme.colors.cross.grayson};
  border-radius: ${rem('8px')};
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('14px')};
  font-weight: 700;
  text-transform: uppercase;
  appearance: none;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => rgba(theme.colors.tenant.mainPale, 0.5)};
    border-color: ${({ theme }) => theme.colors.tenant.main};
  }
`;

export const StyledAddPaymentCtaIcon = styled.span`
  svg {
    width: ${rem('32px')};
    height: ${rem('32px')};

    path {
      fill: black;
    }
  }
`;

export const StyledAddPaymentCtaLabel = styled.span`
  display: flex;
  flex-direction: row;
  align-items: baseline;

  &::after {
    width: ${rem('24px')};
    height: ${rem('24px')};
    margin-left: ${rem('8px')};
    color: ${({ theme }) => theme.colors.main};
    font-size: ${rem('20px')};
    font-weight: 700;
    background-color: ${({ theme }) => theme.colors.tenant.main};
    border-radius: 100%;
    content: '+';
    overflow: hidden;
  }
`;

export const StyledSpinner = styled(Spinner)`
  margin-right: ${rem('5px')};
`;

export const StyledSubText = styled.p`
  font-size: ${rem('16px')};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.mainAlternate};
  margin-top: 0;
  line-height: 1.3;
`;
